export const PUSH_CARD_CONSTANTS = {
  MAX_PUSH_CARDS: 3
} as const;
